import React, { useMemo, useEffect } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { getTranslatedString } from 'helpers/i18n';

import { getUnits } from 'actions/landlordPropertiesActions';

import Form from 'components/ui/Form';
import {
  isLegalNotice,
  getTemplate,
  getTemplateValue,
  isNoticeOfEntryNotice,
  selectedProperties,
  modes,
} from '../NoticeHelpers';
import MultiSelect from '../../../NoticeMultiselect';

const FullWidthSelect = styled(MultiSelect)`
  width: 100%;
`;

const UnitsInput = ({
  values,
  errors,
  touched,
  setFieldValue,
  noticeTemplates,
  properties,
  getUnits,
  units,
}) => {
  const { mode } = values;

  // Reload the units options whenever the properties selection changes.
  useEffect(() => {
    if (values.properties.length !== 1) return;

    console.log('[Units] Reloading units...');
    getUnits(values.properties[0], { for_multiselect_with_floor_riser: true });
  }, [values.properties, values.mode, getUnits]);

  const templateDelivery = useMemo(() => {
    return getTemplateValue(
      getTemplate(noticeTemplates, values.notice_template_id),
      'delivery',
      'any'
    );
  }, [noticeTemplates, values.notice_template_id]);

  const isMultiSelect = useMemo(() => {
    if (isLegalNotice(values) || isNoticeOfEntryNotice(values)) return false;
    return templateDelivery !== 'single_unit';
  }, [values, templateDelivery]);

  const handleChange = (units) => {
    let setUnits = units || [];
    setUnits = Array.isArray(setUnits) ? setUnits : [setUnits];

    if (isLegalNotice(values) || isNoticeOfEntryNotice(values)) {
      setFieldValue('unit_option', 'to_unit_cotenants');
      setFieldValue('mode', modes.SELECTING_UNIT_COTENANTS);
    }

    setFieldValue('units', setUnits);
  };

  // Can only show the unit selection on a single selected property
  if (values.properties.length === 0 || values.properties.length > 1) {
    return null;
  }
  // Only need unit selection in a couple of display modes.
  if (![modes.SELECTING_UNIT, modes.SELECTING_UNIT_COTENANTS].includes(mode)) return null;

  // TODO - work out what to do here for LegalNotice
  if (selectedProperties(values, properties).is_single_unit) return null;

  return (
    <Form.Item
      label={getTranslatedString('landlordPortal.noticeAssignmentForm.units')}
      validateStatus={touched.units && errors.units ? 'error' : null}
      help={touched.units && errors.units}
    >
      <FullWidthSelect
        options={units}
        name="units"
        fullWidth
        withResetSelectAllButtons
        multiple={isMultiSelect}
        value={values.units}
        error={touched.units && errors.units}
        onChange={handleChange}
      />
    </Form.Item>
  );
};

export default connect(
  (store) => {
    return {
      properties: store.landlordProperties.properties,
      units: store.landlordProperties.units,
      noticeTemplates: store.landlordNotices.notice_templates,
    };
  },
  {
    getUnits,
  }
)(UnitsInput);
